// extracted by mini-css-extract-plugin
export default {"wrapper":"M1-z","play":"N1-z"};